import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Button,
    Text,
    Box,
    Flex,
    Icon,
    useColorModeValue,
    VStack,
    Divider,
} from "@chakra-ui/react";
import { TbInfoCircle, TbQuote, TbMapPin, TbUsers } from "react-icons/tb";

function SobreNos({ isOpen, setIsOpen }) {
    const onClose = () => setIsOpen(false);

    // Theme colors
    const modalBg = useColorModeValue("white", "gray.800");
    const textColor = useColorModeValue("gray.700", "gray.200");
    const mutedColor = useColorModeValue("gray.500", "gray.400");
    const quoteBg = useColorModeValue("brand.50", "brand.900");
    const quoteBorder = useColorModeValue("brand.200", "brand.700");
    const quoteText = useColorModeValue("brand.700", "brand.200");
    const dividerColor = useColorModeValue("gray.200", "gray.600");

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="4xl"
            motionPreset="slideInBottom"
            isCentered
            scrollBehavior="inside"
        >
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
            <ModalContent
                borderRadius="2xl"
                overflow="hidden"
                shadow="2xl"
                bg={modalBg}
                mx={4}
            >
                {/* Modern Header */}
                <ModalHeader
                    bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                    color="white"
                    py={5}
                    px={6}
                >
                    <Flex align="center" gap={3}>
                        <Flex
                            align="center"
                            justify="center"
                            bg="whiteAlpha.200"
                            borderRadius="lg"
                            p={2}
                        >
                            <Icon as={TbInfoCircle} boxSize={6} />
                        </Flex>
                        <Box>
                            <Text fontSize="xl" fontWeight="bold">
                                Quem Somos
                            </Text>
                            <Text fontSize="sm" fontWeight="normal" opacity={0.9}>
                                WS Consultoria Climatológica
                            </Text>
                        </Box>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton
                    color="white"
                    top={4}
                    right={4}
                    _hover={{ bg: "whiteAlpha.200" }}
                />

                <ModalBody py={6} px={6}>
                    <VStack spacing={5} align="stretch">
                        {/* Origin Story Section */}
                        <Box>
                            <Flex align="center" gap={2} mb={3}>
                                <Icon as={TbMapPin} color="brand.500" boxSize={5} />
                                <Text fontWeight="semibold" color={textColor}>
                                    Nossa História
                                </Text>
                            </Flex>
                            <Text color={textColor} lineHeight="1.8" fontSize="sm">
                                Ainda jovem, o William Siqueira já começou a medir as temperaturas de Maria da Fé com um termômetro simples, com o intuito de divulgar principalmente as épocas frias da cidade, pela qual é conhecida e também a primeira cidade a extrair o azeite extra virgem no Brasil. Com o passar dos anos foi evoluindo para termômetros mais robustos até chegar à primeira estação meteorológica particular da cidade. Atualmente, o número de estações em Maria da Fé já cresceu para nove e o projeto já expandiu para mais de 200 estações espalhadas por todos os estados do Brasil.
                            </Text>
                        </Box>

                        <Divider borderColor={dividerColor} />

                        {/* Services Section */}
                        <Box>
                            <Flex align="center" gap={2} mb={3}>
                                <Icon as={TbUsers} color="brand.500" boxSize={5} />
                                <Text fontWeight="semibold" color={textColor}>
                                    O Que Fazemos
                                </Text>
                            </Flex>
                            <Text color={textColor} lineHeight="1.8" fontSize="sm">
                                Hoje a WS Consultoria Climatológica atua na área de vendas, instalação e manutenção de equipamentos meteorológicos. Trabalha também na geração de relatórios climatológicos para produtores rurais nos ramos da Olivicultura e da Vinicultura, auxiliamos mais de 150 produtores do Brasil inteiro com relatórios climatológicos mensais e anuais. Somos a única empresa no Brasil a ter um banco de dados de mais de 200 estações meteorológicas com informações de horas frio acumuladas (muito importante na produção de azeite), umidade diária e relatórios de temperatura.
                            </Text>
                        </Box>

                        <Divider borderColor={dividerColor} />

                        {/* Quote Section */}
                        <Box
                            bg={quoteBg}
                            borderRadius="xl"
                            p={5}
                            borderLeft="4px solid"
                            borderColor={quoteBorder}
                        >
                            <Flex align="flex-start" gap={3}>
                                <Icon
                                    as={TbQuote}
                                    color="brand.400"
                                    boxSize={6}
                                    mt={1}
                                    flexShrink={0}
                                />
                                <Box>
                                    <Text
                                        color={quoteText}
                                        fontStyle="italic"
                                        lineHeight="1.8"
                                        fontSize="sm"
                                    >
                                        "Fico muito feliz pela constante ampliação do meu projeto e por trazer tantos benefícios para toda população onde atuamos, principalmente para os produtores que podem mapear melhor o clima das cidades e se adiantar a problemas relacionados ao tempo que afetam suas plantações. Agora o produtor que tem uma parceria firmada com a WS Consultoria Climatológica, vai ter um diferencial para agregar mais valor e informações preciosas de tempo na sua produção, dessa forma beneficiando ainda mais todo o público que precisa desse tipo de conteúdo."
                                    </Text>
                                    <Text
                                        mt={3}
                                        fontSize="sm"
                                        fontWeight="semibold"
                                        color={quoteText}
                                    >
                                        — William Siqueira
                                    </Text>
                                    <Text fontSize="xs" color={mutedColor}>
                                        CEO, WS Consultoria Climatológica
                                    </Text>
                                </Box>
                            </Flex>
                        </Box>

                        {/* Footer Button */}
                        <Flex justify="flex-end" pt={2}>
                            <Button
                                onClick={onClose}
                                bg="brand.600"
                                color="white"
                                _hover={{ bg: "brand.700" }}
                                _active={{ bg: "brand.800" }}
                                borderRadius="xl"
                                px={8}
                                size="md"
                            >
                                Fechar
                            </Button>
                        </Flex>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default SobreNos;
